import { a as r, I as t, j as l, d as e } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const o = (a) => /* @__PURE__ */ r(t, { ...a, name: a.name || "Image", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ l(
    "path",
    {
      d: "M384 341.33a85.33 85.33 0 1 1-170.67 0 85.33 85.33 0 0 1 170.67 0",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  ",",
  /* @__PURE__ */ l(
    "path",
    {
      d: "M0 170.67a128 128 0 0 1 128-128h768a128 128 0 0 1 128 128v682.66a128 128 0 0 1-128 128H128a128 128 0 0 1-128-128zM128 128a42.67 42.67 0 0 0-42.67 42.67v405.84a383.38 383.38 0 0 1 128-21.84c71.89 0 139.16 19.75 196.68 54.12C492.46 473.96 641.05 384 810.67 384c44.37 0 87.32 6.17 128 17.66V170.67A42.67 42.67 0 0 0 896 128zM85.33 668.74v184.59A42.67 42.67 0 0 0 128 896h380.97C488.28 751.25 363.8 640 213.33 640c-45.8 0-89.19 10.3-128 28.74M594.99 896H896a42.67 42.67 0 0 0 42.67-42.67V491.18a383.36 383.36 0 0 0-128-21.85c-141.91 0-265.81 76.97-332.31 191.45A382.98 382.98 0 0 1 594.99 896",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  )
] });
o.defaultProps = e;
export {
  o as default
};
